import React from 'react';
import { Col, Button, Modal } from 'react-bootstrap';

const MobileAppModal = props => (
  <Modal show={props.show} className="modal-pass want-unsubscribe instructions-link">
    <span className="litpog-remove" onClick={props.onHide} />
    <Col md={12}>
      <Modal.Body>
        The Presence app is required for a mobile subscription. Please select the App Store link below to download
        Presence to your phone:
      </Modal.Body>
    </Col>
    <Col md={12}>
      <Modal.Body>
        <a
          className="instructions-link-popup"
          href="https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8"
        >
          https://itunes.apple.com/us/app/presence-walk-with-god/id1400174335?l=ru&ls=1&mt=8
        </a>
      </Modal.Body>
    </Col>
    <Col md={12}>
      <Modal.Footer className="footer-ok-buttons">
        <Button className="buttons-ok" onClick={props.onHide}>
          <span className="buttons-ok-text">Cancel</span>
        </Button>
      </Modal.Footer>
    </Col>
  </Modal>
);

export default MobileAppModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/MobileAppModal.js